import gql from 'graphql-tag'

export default gql`
mutation deleteBatchTrackingFlash($labelIds: [String!]) {
  deleteBatchTrackingFlash(labelIds: $labelIds) {
    _id
    sendHook
  }
}
`


// WEBPACK FOOTER //
// ./src/graphql/mutations/DeleteBatchTrackingFlash.js